import { render, staticRenderFns } from "./SettingsCustomDomain.vue?vue&type=template&id=62363a15&scoped=true&lang=pug&"
import script from "./SettingsCustomDomain.vue?vue&type=script&lang=js&"
export * from "./SettingsCustomDomain.vue?vue&type=script&lang=js&"
import style0 from "./SettingsCustomDomain.vue?vue&type=style&index=0&id=62363a15&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62363a15",
  null
  
)

export default component.exports